// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CydN","content":"styles_content__svSGz","row":"styles_row__2T0Bj","footer":"styles_footer__j6Cvr","phraseLength":"styles_phraseLength__1duoh"};